import { useTranslation } from 'react-i18next';
import type { ProfileKind } from 'api/technicianImportContract';

const LABELS: Record<ProfileKind, string> = { installer: 'Installer', merch: 'Merchandiser' };

/** The technician's declared profile (Installateur / Merch), nothing when he declared none. */
const ProfileKindTag = ({ kind }: { kind: ProfileKind | null | undefined }) => {
  const { t } = useTranslation();
  if (!kind || !LABELS[kind]) return null;
  return (
    <span className="inline-flex h-[19px] shrink-0 items-center rounded-[6px] border border-input px-[6px] text-[11px] font-medium text-muted-foreground">
      {t(LABELS[kind])}
    </span>
  );
};

export default ProfileKindTag;
